import Vue from 'vue';
import ContentManager from './base';
import Remote from '../remote';
import Utils from '../utils';
import Panel from '../panels';
import flash from '../flash';
import Comments from '../../comments/comments';

export default class EvaluationViewer extends ContentManager {
  constructor(viewer, context, remote, options) {
    super(viewer, context, remote, options);
    this.remote = new Remote('/learn/behaviors');
    this.report_states = {};
  }

  loadModal() {
    this.panel = new Panel(Panel.NODE, '', {
      modal_id: 'content-modal',
      name: this.context.getName(),
      fullscreen: this.options.fullscreen,
    });

    Utils.promiseWithFuse(
      () => {
        this.panel.updateContent('<div class="lp--panelLoader"></div>');
      },
      this.load().then((result) => {
        this.panel.updateContent(result.cnt);

        this.attach();

        this.panel.eventSource.one('willHide.panel', () => {
          this.detach();
        });

        return this.setupModal(this.panel, result.documents);
      }),
      400,
    );
    return Promise.resolve(this.panel);
  }

  attach() {
    super.attach();

    this.panel.content.find('.btn-save-form').on(`keypress ${Utils.tapInteractionEvent}.evaluation`, (ev) => {
      this.deadline_save({ states_and_locks: this.report_states }).then(() => {
        this.panel.hide();
      });
    });

    this.panel.content.find('.lp--js-nodeComment').on(`keypress ${Utils.tapInteractionEvent}.comments`, (ev) => {
      $(document).trigger(Comments.EventTriggerName, {
        entity_uuid: this.context.getId(),
        entity_type: 'node',
      });
    });

    this.panel.content.find('.lp--js-triggerComment').on(`keypress ${Utils.tapInteractionEvent}.comments`, (ev) => {
      $(ev.target).blur();
      const post_uuid = ev.currentTarget.getAttribute('data-post-uuid');
      $(document).trigger(Comments.EventTriggerName, {
        entity_uuid: post_uuid,
        entity_type: 'evaluation_report',
      });
    });

    this.panel.content.find('.sneak-peak').on(Utils.interactionEvent, (ev) => {
      $(ev.currentTarget).closest('.lp--blogPostListItem').find('.draft').removeClass('draft');
    });
  }

  detach() {
    super.detach();
    this.panel.content.off('.evaluation');
    this.panel.content.find('.comment').off('.comments');
    this.panel.content.find('.lp--js-nodeComment').off('.comments');
    this.panel.content.find('.lp--js-triggerComment').off('.comments');
  }

  setupModal(panel, documents) {
    this.setupModal(panel);
    if (documents.length > 0) {
      const vue = new Vue({
        el: panel.content.find('.lp--curriculumEditorContainer')[0],
        template: `<div class="lp--curriculumEditor" tabindex="-1">
      <section class="lp--curriculumHeader">
        <a href="#" class="lp--curriculumModal-close" v-on:click="closeModal" :title="i18n('app_close')"></a>
        <h2 class="lp--curriculumItemTitle">{{curriculumViewerTitle}}</h2>
      </section>
      <curriculum-menu :documents="documents" :shouldDisplayOverview="hasTags" :selectedDocument="currentDocument" :editMode="editMode" v-on:navigate="navigate"></curriculum-menu>        
      <curriculum-document v-if="currentDocument" :currentDocument="currentDocument" :editMode="editMode"></curriculum-document>        
      <curriculum-overview v-if="shouldDisplayOverview && hasTags"  :documents="documents" :editMode="editMode"></curriculum-overview>
      <curriculum-viewer-placeholder v-if="shouldDisplayOverview && !hasTags"></curriculum-viewer-placeholder>
      </div>`,
        methods: {
          i18n: function (str) {
            return i18n.__(str);
          },
          navigate: function (document_uuid) {
            if (document_uuid) {
              for (let i = 0; i < this.documents.length; i++) {
                if (document_uuid == this.documents[i].uuid) {
                  this.currentDocument = this.documents[i];
                }
              }
            } else {
              this.currentDocument = null;
            }
          },
          closeModal: function () {
            _t.modal.hide();
          },
        },
        computed: {
          curriculumViewerTitle: function () {
            return i18n.__('curriculum_viewer_title');
          },
          shouldDisplayOverview: function () {
            this.currentDocument;
            return !this.currentDocument;
          },
          hasTags: function () {
            for (var i = 0; i < this.documents.length; i++) {
              for (var j = 0; j < this.documents[i].abilities.length; j++) {
                if (this.documents[i].abilities[j].checked) {
                  return true;
                }
              }
              for (var j = 0; j < this.documents[i].content.length; j++) {
                if (this.documents[i].content[j].checked) {
                  return true;
                }
              }
            }
            return false;
          },
        },
        data: function () {
          return {
            documents: documents,
            currentDocument: documents[0],
            editMode: false,
          };
        },
      });
    }
    return panel;
  }

  setupModal(panel) {
    super.setupModal(panel);
    return panel;
  }

  load(container) {
    return this.remote
      .get(this.options.getURLFor(ContentManager.Content.Evaluation, this.context, this.options), { type: 'json' })
      .on('noAccess', () => {
        // Redirect to an url we want to return to after the login
        window.location.replace('/learn/' + this.options.session_id);
      })
      .then((result) => {
        try {
          this.immersiveReader.buildFromContent(result, 'evaluation');
        } catch (error) {
          console.error(error);
        }
        return this.parseResult(result);
      })
      .catch((err) => {
        console.log(err);
        flash(i18n.__('error_behavior_load_failed'));
      });
  }

  parseResult(result) {
    let handin = {
      body: '',
      locked: false,
      state: 'blank',
      editable: false,
    };

    if (result.EvaluationSessions && result.EvaluationSessions[0].EvaluationReports.length > 0) {
      const evaluationReport = result.EvaluationSessions[0].EvaluationReports[0];
      handin = {
        uuid: evaluationReport.uuid,
        locked: evaluationReport.locked,
        state: evaluationReport.state,
        isDraft: evaluationReport.isDraft,
        body: evaluationReport.state !== 'blank' ? evaluationReport.body : i18n.__('work_not_started'),
        attachments: evaluationReport.Attachments,
      };
    }

    const cnt = $(
      Handlebars.templates['behaviors/evaluation/viewer_single'](
        $.extend(
          {
            navigation: this.options.navigation,
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
            handin: handin,
            draft: handin.isDraft ? 'draft' : '',
          },
          result,
        ),
      ),
    );

    return {
      cnt,
      documents: result.documents,
    };
  }
}
